import store from 'redux/store';
import { ToastActions } from 'redux/toast';

export default function dispatchToast({ message, type, autohide }) {
  store.dispatch(ToastActions.addToast({ message, type, autohide }));
}